import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthModel from "../model/auth";
import { getErrorMessage } from "../utils/errors";
import { isValidEmail, normalizeEmail } from "../utils/validators";

export const ViewModelLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuthModel();

  const [dialog, setDialog] = useState<{
    type: "success" | "error" | null;
    message: string;
  }>({ type: null, message: "" });

  const handleLogin = async (email: string, password: string) => {
    if (!email.trim() || !password.trim()) {
      setDialog({
        type: "error",
        message: "Por favor, preencha todos os campos.",
      });
      return;
    }

    if (!isValidEmail(email)) {
      setDialog({
        type: "error",
        message: "Insira um email válido. Números de telefone não são aceites.",
      });
      return;
    }

    await login(
      { email: normalizeEmail(email), password },
      {
        response: (data: any) => {
          setDialog({
            type: "success",
            message: "Login realizado com sucesso!",
          });
          setTimeout(() => {
            navigate("/painel");
          }, 500);
        },
        error: (error: any) => {
          const data = error.response?.data;
          // Conta criada por um administrador: confirmar o código e definir a senha
          if (data?.status === "USER_PENDING") {
            navigate("/recuperar-senha", {
              state: {
                pending: true,
                email: data.email_whatsapp,
                hashTail: data.hash_confirmation,
              },
            });
            return;
          }
          setDialog({
            type: "error",
            message: getErrorMessage(error, "Credenciais inválidas."),
          });
        },
      }
    );
  };

  return {
    handleLogin,
    dialog,
  };
};
